export const initialGenerationState = {
  isLoading: false,
  isError: false
};

const ON_CHANGE = 'ON_CHANGE';
const ON_SUBFOLDER_CHANGE = 'ON_SUBFOLDER_CHANGE';
const ON_SUBMIT = 'ON_SUBMIT';
const ON_ERROR = 'ON_ERROR';
const ON_ERROR_EXISTS = 'ON_ERROR_EXISTS';
const ON_ERROR_INVALID_URL = 'ON_ERROR_INVALID_URL';
const ON_ERROR_NO_INTERNAL_PAGE_NO_HOMEPAGE_PROJECT = 'ON_ERROR_NO_INTERNAL_PAGE_NO_HOMEPAGE_PROJECT';
const ON_ERROR_NO_INTERNAL_PAGE_NO_HOMEPAGE_REVIEW = 'ON_ERROR_NO_INTERNAL_PAGE_NO_HOMEPAGE_REVIEW';
const ON_ERROR_UNRESOLVABLE_URL = 'ON_ERROR_UNRESOLVABLE_URL';
const ON_ERROR_PAGE_RATE_LIMITED = 'ON_ERROR_PAGE_RATE_LIMITED';
const ON_ERROR_TRIAL_REVIEW_LIMIT = 'ON_ERROR_TRIAL_REVIEW_LIMIT';
const ON_SUCCESS = 'ON_SUCCESS';
const ON_RESET = 'ON_RESET';

export const generationReducer = (state, action) => {
  switch (action.type) {
    case ON_CHANGE:
      return {
        ...state,
        isLoading: false,
        isError: false,
        url: action.url
      };
    case ON_SUBFOLDER_CHANGE:
      return {
        ...state,
        isLoading: false,
        isError: false,
        subFolder: action.subFolder
      };
    case ON_SUBMIT:
      return {
        ...state,
        isLoading: true,
        isError: false,
        isSuccess: false
      };
    case ON_ERROR:
      return {
        ...state,
        isLoading: false,
        isError: true,
        isSuccess: false,
        errorMessage: 'error'
      };
    case ON_ERROR_EXISTS:
      return {
        ...state,
        isLoading: false,
        isError: true,
        isSuccess: false,
        errorMessage: 'exists'
      };
    case ON_ERROR_INVALID_URL:
      return {
        ...state,
        isLoading: false,
        isError: true,
        isSuccess: false,
        errorMessage: 'invalid'
      };
    case ON_ERROR_NO_INTERNAL_PAGE_NO_HOMEPAGE_PROJECT:
      return {
        ...state,
        isLoading: false,
        isError: true,
        isSuccess: false,
        errorMessage: 'no_internal_no_homepage_project'
      };
    case ON_ERROR_NO_INTERNAL_PAGE_NO_HOMEPAGE_REVIEW:
      return {
        ...state,
        isLoading: false,
        isError: true,
        isSuccess: false,
        errorMessage: 'no_internal_no_homepage_review'
      };
    case ON_ERROR_UNRESOLVABLE_URL:
      return {
        ...state,
        isLoading: false,
        isError: true,
        isSuccess: false,
        errorMessage: 'unresolvable',
        error: {
          ...action.payload
        }
      };
    case ON_ERROR_PAGE_RATE_LIMITED:
      return {
        ...state,
        isLoading: false,
        isError: true,
        isSuccess: false,
        errorMessage: 'page_rate_limit'
      };
    case ON_ERROR_TRIAL_REVIEW_LIMIT:
      return {
        ...state,
        isLoading: false,
        isError: true,
        isSuccess: false,
        errorMessage: 'tiral_review_limit'
      };
    case ON_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        isSuccess: false
      };
    case ON_RESET:
      return {
        ...state,
        ...initialGenerationState
      };
    default:
      return state;
  }
};
